import { VideoJsPlayer } from 'video.js';

export function extractPlayerAttributes(player: VideoJsPlayer) {
  return {
    totalLength: Math.round(player.duration()),
    position: Math.round(player.currentTime()),
  };
}
